export const BRIDGE_NAME = {
  MYCLE: 'MycleBridge',
  PARTNERS: 'AppNavigator',
} as const

export const PLATFORM = {
  IOS: 'ios',
  ANDROID: 'android',
} as const

export const MYCLE_BRIDGE_COMMANDS = {
  CLOSE_WEBVIEW: 'closeWindow',
  SHOW_COMMERCE_PAYMENT_VIEW: 'showCommercePaymentView',
  REMOVE_MAINTENANCE_ITEM: 'removeMaintenanceItem',
  SET_SCREEN_BRIGHTNESS: 'setScreenBrightness',
  RESET_SCREEN_BRIGHTNESS: 'resetScreenBrightness',
  /** OS 브라우저(사파리·크롬)로 URL 열기 — openExternalWeb.ts 참고 */
  OPEN_EXTERNAL_WEB: 'openExternalWeb',
  /** 웹에서 데이터를 바꿨으니 앱 화면을 다시 불러오라는 신호 */
  DATA_CHANGED: 'onDataChanged',
} as const

export const PARTNERS_BRIDGE_COMMANDS = {
  CLOSE: 'close',
} as const

/** 웹뷰를 띄운 네이티브 앱 */
export const WEBVIEW_APP = {
  MYCLE: 'mycle',
  PARTNERS: 'partners',
} as const
